import React, { useState } from 'react';
import client from '../apollo-client';

import PageHero from '../layouts/PageHero';
import { CITIES_PAGE_INTERFACE, CITIES_PAGE } from '../api/citiesPage';
import dynamic from 'next/dynamic';
const Newsletter = dynamic(() => import('../layouts/Newsletter/Newsletter'));
import Head from 'next/head';
import { AllCities } from '../components/AllCities/AllCities';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import Card from '../components/Card';
import Trustbar from '../components/Trust/Trustbar';
import CitiesModal from '../components/CitiesModal.tsx';
import { replaceTripshepherdWithSeeSight } from '../utils/trip-sheppered-text';
const Link = dynamic(() => import('next/link'));

export async function getStaticProps() {
  const { data } = await client.query<CITIES_PAGE_INTERFACE>(CITIES_PAGE);

  return {
    props: {
      citiesPage:
        data?.citiesPage &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.citiesPage))
        ),
      headData: {
        metaDescription: data.citiesPage.metaDescription,
        title: data.citiesPage.pageTitle
      }
    }
  };
}

const Cities = ({ citiesPage, headData }: CITIES_PAGE_INTERFACE) => {
  return (
    <div>
      <Head>
        <meta
          name="og:title"
          content={replaceTripshepherdWithSeeSight(headData.title)}
        />
        <meta
          name="og:description"
          content={replaceTripshepherdWithSeeSight(headData.metaDescription)}
          key="metadescription"
        />
        <title>{replaceTripshepherdWithSeeSight(headData.title)}</title>
        <meta
          name="description"
          content={replaceTripshepherdWithSeeSight(headData.metaDescription)}
          key="metadescription"
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
        <link
          href={replaceTripshepherdWithSeeSight(citiesPage.canonical)}
          rel="canonical"
          key="canonical"
        />
      </Head>
      <div className="relative">
        <PageHero
          title={'OUR CITIES'}
          snippet={'Let us show you the places we call home'}
          media={
            'https://res.cloudinary.com/see-sight-tours/video/upload/f_auto,q_auto,t_header/v1632763195/strapi/CitiesPage-Desktop.mp4'
          }
          video={true}
        />
        <CitiesModal />
      </div>
      <Trustbar />
      <section className="flex flex-col w-full justify-start pb-[3%]">
        <div className="pl-[8%] xl:pl-[10%]">
          <h2 className="font-bold lg:font-semibold text-lg lg:text-4xl capitalize text-[#333333] pt-6">
            Featured Cities
          </h2>

          <Swiper
            className="swiper_123 relative"
            spaceBetween={40}
            slidesPerView={1}
            effect="slide"
            grabCursor
            a11y={{ enabled: true }}
            observer
            observeParents
            observeSlideChildren
            breakpoints={{
              280: {
                slidesPerView: 1.15,
                spaceBetween: 16
              },
              400: {
                slidesPerView: 1.3,
                spaceBetween: 20
              },
              640: {
                slidesPerView: 1.5,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 1.7,
                spaceBetween: 20
              },
              1024: {
                slidesPerView: 2.5
              },
              1200: {
                slidesPerView: 2.5
              }
            }}
          >
            {citiesPage.featured &&
              citiesPage.featured.map((cities, index) => {
                if (cities.city) {
                  return (
                    <SwiperSlide key={cities.city.id}>
                      <Link href={`/${cities.city.slug}`}>
                        <Card
                          index={index}
                          slug={cities.city.slug}
                          image={cities.city.cardMedia[0]?.url}
                          cardSnippet={cities.city.cardSnippet}
                          city={cities.city.name}
                        />
                      </Link>
                    </SwiperSlide>
                  );
                }
              })}
          </Swiper>
        </div>

        <AllCities cities={citiesPage.cities} />
        <Newsletter />
      </section>
    </div>
  );
};

export default Cities;
